import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { formatMoney } from '../../../../shared/js/format';

import { createRenderSortingTH } from '../shared/new-table/renderers';

import Calendar from '../shared/calendar/main';
import Filters from '../shared/filters/main';
import Table from '../shared/new-table/main';

import wrapMain from './wrap-main';

import { selectors, actions } from './';

import './index.less';

function Main(props) {
	return (
		<div className="alert-analytics-table">
			<div className='clearfix'>
				<Filters
					intl={props.intl}
					{...props.filters}
					filters={props.filters} // for crutch support
				/>
			</div>
			<div className='alerts-analytics-row'>
				<Calendar
					className='alerts-analytics-calendar'
					intl={props.intl}
					{...props.calendar}
					onInit={props.calendar.calendarInit}
					onToggle={props.calendar.calendarToggle}
					onChange={props.calendar.calendarChange}
					onApply={props.calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.apply}
				>
					{props.intl('Apply')}
				</button>
				<button
					className='ui-btn ui-btn-secondary ui-icon-clear'
					onClick={props.clear}
				/>
			</div>
			<List
				pagination={props.pagination}
				tableData={props.tableData}
				intl={props.intl}
				rows={props.rows}
				apply={props.apply}
			/>
		</div>
	);
}

function List({ tableData, intl, rows, pagination, apply }) {
	return (
		<div>
			<div className='alerts-analytics-table-wrapper'>
				<Table
					payload={{ apply }}
					table={tableData.table}
					rows={tableData.rows}
					renderTH={createRenderSortingTH({
						sortedBy: tableData.sortedBy,
						sort: tableData.sort
					})}
				/>
			</div>

			<div className='margin-top-5'>
				Total Leads: {formatMoney(rows.reduce((sum, row) => sum + +row.leads, 0))}
			</div>

			{(rows.length < pagination.total) && (
				<div className='banners-button-wrapper'>
					<button
						className='ui-btn ui-btn-secondary banners-button'
						onClick={pagination.showMore}
					>
						{intl('Show more')}
					</button>
				</div>
			)}
		</div>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		rows: selectors.select(state, 'data'),
		// -----------------------------------------
		table: selectors.getTable(state),
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		table: bindActionCreators(actions.table, dispatch),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch),
		pagination: bindActionCreators(actions.pagination, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		tableData: {
			...stateProps.table,
			...dispatchProps.table
		},
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		},
		pagination: {
			...stateProps.pagination,
			...dispatchProps.pagination
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/main.js